import { render } from "./TakaraSagashi.vue?vue&type=template&id=5d8929cc"
import script from "./TakaraSagashi.vue?vue&type=script&lang=js"
export * from "./TakaraSagashi.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__